<template>
<div id="layout-proforma-factura" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Generación de Proforma de Facturas" class="elevation-1 px-5 py-3" >
                    <br>
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="genera_proforma">Generar Proforma PDF</v-tab>
                        <v-tab key="generar_reporte">Reporte de Layouts Cargados</v-tab>
                        
                        <v-tab-item key="genera_proforma" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                
                                </v-card-text>
                                
                                <v-card-text>
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6" >
                                            <v-row>
                                                <v-col sm="10" md="10" lg="10" >
                                                    1.- Descargar Layout Datos de Factura:
                                                </v-col>
                                                <v-col sm="1" md="1" lg="1" >
                                                    <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout_Proforma.xlsx" >
                                                    <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                        <v-icon dark>receipt</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                                </v-col>                                        
                                            </v-row>                                        
                                            <v-row>
                                                <v-col sm="10" md="10" lg="10" >
                                                    2.- Carga de Layout de Factura:
                                                </v-col>
                                                <v-col sm="1" md="1" lg="1" >
                                                    <upload-excel-component idInput="pedimentosKey" :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                </v-col>                                                
                                            </v-row>
                                        </v-col>                                        
                                    </v-row>
                                    
                                        
                                
                                </v-card-text>

                                <v-card-text>                                
                                    <v-refresh-button :funcion="cargar" />

                                    <v-client-table ref="vuetable" :data="datos" :columns="columns_datos" :options="options_datos" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="secondary" title="Descagar Proforma" 
                                            v-if="props.row.pdf!=undefined && props.row.pdf!=''" @click="downloadReporte(props.row.pdf)" >
                                            <v-icon dark>mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                        <!--v-btn text icon color="success" title="Regenerar PDF" 
                                            v-if="props.row.pdf!=undefined && props.row.pdf!=''" @click="regenerarPdf(props.row.id, props.row.pdf)" >
                                            <v-icon dark>refresh</v-icon>
                                        </v-btn-->
                                        <v-btn text icon color="red" title="Eliminar" @click="eliminarLayout(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                                </v-card-text>

                            </div>     
                        </v-tab-item>
                        <v-tab-item key="generar_reporte" >
                            <br>
                            <v-card-text>
                                <v-form ref="form">
                                <v-row row wrap>
                                    <v-col sm="12" md="4" lg="4" >
                                    
                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model_busqueda.fecha_de" clearable label="Fecha Factura Inicial" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_de = parseDate(model_busqueda.fecha_de)" v-mask="'####-##-##'"
                                            :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                                        </template>

                                        <v-date-picker v-model="model_busqueda.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu1 = false" >
                                            Cancelar
                                        </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                    </v-col>
                                    <v-col sm="12" md="4" lg="4" >
                                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model_busqueda.fecha_a" clearable label="Fecha Factura Final" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_a= parseDate(model_busqueda.fecha_a)" v-mask="'####-##-##'"
                                            :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model_busqueda.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu2 = false" >
                                            Cancelar
                                        </v-btn>
                                        </v-date-picker>
                                    </v-menu>

                                    </v-col>
                                    
                                </v-row>
                                </v-form>
                                
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="info" @click="generar_reporte_sqs()" >
                                    <v-icon>done</v-icon>Generar Reporte
                                </v-btn>
                                
                            </v-card-actions>
                            </v-card-text>
                            

                            <v-card-text>
                                <v-refresh-button :funcion="cargar_reportes" />
                                <v-client-table ref="vuetable" :data="reportes" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)">
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                            </v-card-text>


                        </v-tab-item>
                    </v-tabs>                                                                   
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

   
    

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

window.html2canvas = html2canvas
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },

data: () => ({
        emisores: [],
        file_adjunto: null,
        estatus_arr:["ACTIVO","INACTIVO"],
        password:"",
        con_password:0,
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        URL:"",        
        data_resumen:[],
        
        columns_resumen: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento",
            "no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
        options_resumen: {
            filterable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
            sortable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia","error","URL"],
            headings: {
                tipo_operacion:"Tipo Operacion",
                patente:"patente",
                seccion_aduanera:"Sección Aduanera",
                numero_pedimento:"Número Pedimento",
                fecha_pago_real:"Fecha Pago Real",
                fecha_entrada:"Fecha Entrada",
                anio:"Año",
                clave_documento:"Clave Documento",
                "no_maquina":"Maquina No.",
                "planta_referencia":"Planta",
                marca:"Marca",
                modelo:"Modelo",
                serie:"Serie",
                informacion:"Información",
                error:"Error",
            }
        },
        modal_pedimentos:false,
        permisoEliminar: false,
        menu1: false,
        menu2: false,
        plantas_arr: [],
        edificios_arr: [],
        lineas_arr: [],
        codigo_qr:"",
        modal:false,
        modal_qr:false,
        model_editable:{
            pedimento: "",
            anio: "",
            no_maquina: "",
            linea: "",
            marca: "",
            modelo: "",
            descripcion: "",
            serie: "",
            observaciones: "",
            edificio: "",
            estatus: "",
            planta_referencia:""
        },
        model_busqueda:{
            rfc:"",
            usuario: "",
            fecha_de:"",
            fecha_a:"",                      
            reporte_url: "/reportes_ws/reporte_factura_layout/",
            nombre_reporte: "Proforma Factura",
            tipo: "Proforma Layout PDF",
        },
        name: "datagrid",
        importData: {},
        arrClaves:[],        
        URL: "",

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reportes",
                disabled: true,
                to: ""
            },
            {
                text: "Proforma de Factura",
                disabled: true,
                to: ""
            }
        ],
        loadingPlantas:false,
        loadingEdificios:false,
        loadingLineas:false,
        datos: [],
        columns_datos: ["id", "created_at", "iniciales", "factura", "fecha_factura", "empresa_destino", "error_pdf", "actions"],
        options_datos: {
            filterable: ["id", "created_at", "iniciales", "factura", "fecha_factura", "empresa_destino", "error_pdf"],
            sortable: ["id", "created_at", "iniciales", "factura", "fecha_factura", "empresa_destino", "error_pdf"],

            headings: {
                id: "No. Proceso",
                created_at: "Solicitado",
                iniciales: "Usuario",
                factura: "Factura",            
                fecha_factura: "Fecha Factura",
                empresa_destino: "Empresa Destino",
                error_pdf: "Error PDF",
                actions: "Opciones"
            }
        },
        reportes:[],
        columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error"],
            sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error"],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",            
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },
        columnsEtiquetas: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error", "actions"],
        optionsEtiquetas: {
            filterable: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],
            sortable: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],

            headings: {
                "planta_referencia":"Planta", 
                "no_maquina":"No. Maquina", 
                "edificio":"Edificio", 
                "linea":"Línea", 
                "fecha_pago_real":"Fecha Pedimento", 
                "pedimento":"No. Pedimento",
                actions: "Opciones"
            }
        },
                
        
        encabezadoLayout: {
            "RFC o TAX ID":"RFC o TAX ID",
            "RFC o TAX ID Destino":"RFC o TAX ID Destino",
            "Contacto":"Contacto",
            "Telefono":"Telefono",
            "Import of Records":"Import of Records",
            "Número de factura":"Número de factura",
            "Fecha de factura":"Fecha de factura",
            "INCOTERM":"INCOTERM",
            "Proyecto":"Proyecto",
            "Cantidad":"Cantidad",
            "Unidad de Medida":"Unidad de Medida",
            "Número de Parte":"Número de Parte",
            "Descripción":"Descripción",
            "Fracción Arancelaria":"Fracción Arancelaria",
            "País de Origen":"País de Origen",
            "Precio Unitario":"Precio Unitario",
            "Total":"Total",
            "Observaciones":"Observaciones",
            "Peso":"Peso",
            "Número de Bultos":"Número de Bultos",    
            "Dimensiones":"Dimensiones"        
        },
        
        camposLayout: [{
            "RFC o TAX ID":"[RFC o TAX ID de Empresa Exportadora]",
            "RFC o TAX ID Destino":"[RFC o TAX ID Empresa Destino]",
            "Contacto":"[Contacto]",
            "Telefono":"[Teléfono]",
            "Import of Records":"[Import of Records - Opcional]",
            "Número de factura":"[Número de factura]",
            "Fecha de factura":"[Fecha de factura en formato dd/mm/aaa]",
            "INCOTERM":"[INCOTERM]",
            "Proyecto":"[Proyecto]",
            "Cantidad":"[Cantidad]",
            "Unidad de Medida":"[Unidad de Medida]",
            "Número de Parte":"[Número de Parte]",
            "Descripción":"[Descripción]",
            "Fracción Arancelaria":"[Fracción Arancelaria]",
            "País de Origen":"[País de Origen]",
            "Precio Unitario":"[Precio Unitario USD]",
            "Total":"[Total USD]",
            "Observaciones":"[Observaciones]",
            "Peso":"[Peso en KG]",
            "Número de Bultos":"[Número de Bultos]",    
            "Dimensiones":"[Dimensiones]"        
        },
        {
            "RFC o TAX ID":"Ingresar información a partir de esta fila (3ra fila) en adelante",
        }
        ],
        camposObligatorios: [
            "RFC o TAX ID",
            "RFC o TAX ID Destino",
            "Contacto",
            "Telefono",
            "Número de factura",
            "Fecha de factura",
            "INCOTERM",
            "Proyecto",
            "Cantidad",
            "Unidad de Medida",
            "Número de Parte",
            "Descripción",
            "Fracción Arancelaria",
            "País de Origen",
            "Precio Unitario",
            "Total",
            "Observaciones",
            "Peso",
            "Número de Bultos",
        ],        
    }),
    methods: {
        
        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaAnio: function() {
            if (this.model_busqueda.fecha_de != "" && this.model_busqueda.fecha_a != "") {
                var inicio = moment(this.model_busqueda.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model_busqueda.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        
        beforeUpload(file) {
            var self = this;
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                self.file_adjunto = file;
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            self.file_adjunto = null;
            return false;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },        
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
        validaFloat: function(numero) {
            const pattern = /^\d*(\.\d*)?$/;
            return pattern.test(numero);
        },
        
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        cargarEmisores: function () {
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    cliente: cliente_id,
                };
                axios.post(this.$hostname + 'catalogos/emisores_destinatarios/get_emisores/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.emisores = res.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err.response);
                    });
            }

        },
        get_emisor: function(rfc_emisor){
            var search = this.emisores.find(function (e) {
                return e.rfc.trim().toLowerCase() == rfc_emisor.toString().trim().toLowerCase();
            });
            if (search) {                
                var emisor = search;
                
                emisor["pais_nombre"] = "";
                if(emisor["pais"] != undefined && emisor["pais"] !=null){
                    emisor["pais_nombre"] = emisor["pais"]["clave_m3"];
                }

                emisor["estado_nombre"] = "";
                if(emisor["estado"] != undefined && emisor["estado"] !=null){
                    emisor["estado_nombre"] = emisor["estado"]["nombre"];
                }

                return emisor;
                
            } else
                return false;
        },        
        trimChar: function(str, charToRemove) {
            // Construye la expresión regular para buscar el carácter al inicio y al final
            const regex = new RegExp(`^${charToRemove}+|${charToRemove}+$`, 'g');
            // Usa replace para eliminar el carácter al inicio y al final
            return str.replace(regex, '');
        },
                
        validaCargaLayout: async function (results) {
            var self = this;
            //return new Promise(function(resolve, reject){
            var emisores = {};
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 1000){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 1000, favor de verificar.";                
                } else {
                    for (var k in results) {                                                

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            //Buscar rfc en emisores destinatarios y traer el domicilio completo
                            if(emisores[results[k]["RFC o TAX ID"]]){
                                var emisor = emisores[results[k]["RFC o TAX ID"]];
                            } else {                                
                                var emisor = self.get_emisor(results[k]["RFC o TAX ID"]);                                
                                emisores[results[k]["RFC o TAX ID"]] = emisor;
                            }
                            
                            if (emisor === false){
                                errores++;
                                errorTmp = '<br/>' + "- El RFC o TAX ID '" + results[k]["RFC o TAX ID"] + "' no existe en catálogo de Emisores/Destinatarios.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } 
                            if (emisor !== false){
                                results[k]["Empresa Exportadora"] = emisor["razon_social"];
                                results[k]["Calle y Número"] = emisor["calle"] + " #"+ emisor["numero_exterior"] +" "+ emisor["numero_interior"];
                                results[k]["Colonia"] = emisor["colonia"];
                                results[k]["Municipio y Estado"] = emisor["ciudad"]+", "+emisor["estado_nombre"];                                
                                results[k]["Municipio y Estado"] = self.trimChar(results[k]["Municipio y Estado"], ", ");
                                results[k]["País"] = emisor["pais_nombre"];
                                results[k]["Codigo Postal"] = emisor["codigo_postal"];
                                results[k]["MID"] = emisor["referencia"];                                
                            }

                            if(emisores[results[k]["RFC o TAX ID Destino"]]){
                                var emisor_destino = emisores[results[k]["RFC o TAX ID Destino"]];
                            } else {
                                var emisor_destino = self.get_emisor(results[k]["RFC o TAX ID Destino"]);
                                emisores[results[k]["RFC o TAX ID Destino"]] = emisor_destino;
                            }

                            if (emisor_destino === false){
                                errores++;
                                errorTmp = '<br/>' + "- El RFC o TAX ID Destino'" + results[k]["RFC o TAX ID Destino"] + "' no existe en catálogo de Emisores/Destinatarios.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } 
                            if (emisor_destino !== false){
                                results[k]["Empresa Destino"] = emisor_destino["razon_social"];
                                results[k]["Calle y Número2"] = emisor_destino["calle"] + " #"+ emisor_destino["numero_exterior"] +" "+ emisor_destino["numero_interior"];
                                results[k]["Colonia2"] = emisor_destino["colonia"];
                                results[k]["Municipio y Estado2"] = emisor_destino["ciudad"]+", "+emisor_destino["estado_nombre"];                                
                                results[k]["Municipio y Estado2"] = self.trimChar(results[k]["Municipio y Estado2"], ", ");
                                results[k]["País2"] = emisor_destino["pais_nombre"];
                                results[k]["Codigo Postal2"] = emisor_destino["codigo_postal"];                                
                            }
                            
                            var fechaOrig = results[k]["Fecha de factura"];
                            results[k]["Fecha de factura"] = this.parseDateExcel(results[k]["Fecha de factura"]); 
                            
                            if (results[k]["Fecha de factura"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La Fecha de factura '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaFloat(results[k]['Cantidad'])){
                                errores++;
                                errorTmp = '<br/>' + "- La Cantidad '" + results[k]['Cantidad'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['Cantidad'] = parseFloat(results[k]['Cantidad']);
                            }

                            if(!this.validaFloat(results[k]['Precio Unitario'])){
                                errores++;
                                errorTmp = '<br/>' + "- El Precio Unitario '" + results[k]['Precio Unitario'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['Precio Unitario'] = parseFloat(results[k]['Precio Unitario']);
                            }

                            if(!this.validaFloat(results[k]['Total'])){
                                errores++;
                                errorTmp = '<br/>' + "- El Total '" + results[k]['Total'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['Total'] = parseFloat(results[k]['Total']);
                            }
                            
                            if(!this.validaFloat(results[k]['Peso'])){
                                errores++;
                                errorTmp = '<br/>' + "- El Peso '" + results[k]['Peso'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['Peso'] = parseFloat(results[k]['Peso']);
                            }
                            
                            if(!this.validaFloat(results[k]['Número de Bultos'])){
                                errores++;
                                errorTmp = '<br/>' + "- El Número de Bultos '" + results[k]['Número de Bultos'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['Número de Bultos'] = parseFloat(results[k]['Número de Bultos']);
                            }

                                                                                  

                        }
                        
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                self.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            this.importData = {};
            try {    
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var rfc = this.$local_storage.get("rfc");
                    for (var k in results) { 
                        if(this.importData.rfc == undefined){ //Si es el primero se toman los datos generales y el primer concepto
                            this.importData = {  
                                rfc: rfc, 
                                usuario: this.$local_storage.get("id_usuario"),
                                "empresa_exportadora": results[k]['Empresa Exportadora'],
                                "rfc_exportadora": results[k]['RFC o TAX ID'],
                                "calle": results[k]['Calle y Número'],
                                "colonia": results[k]['Colonia'],
                                "estado": results[k]['Municipio y Estado'],
                                "pais": results[k]['País'],
                                "cp": results[k]['Codigo Postal'],
                                "mid": results[k]['MID'],
                                "empresa_destino": results[k]['Empresa Destino'],
                                "rfc_destino": results[k]['RFC o TAX ID Destino'],
                                "calle_destino": results[k]['Calle y Número2'],
                                "colonia_destino": results[k]['Colonia2'],
                                "estado_destino": results[k]['Municipio y Estado2'],
                                "pais_destino": results[k]['País2'],
                                "cp_destino": results[k]['Codigo Postal2'],
                                "contacto": results[k]['Contacto'],
                                "telefono": results[k]['Telefono'],
                                "import_of_records": results[k]['Import of Records']!=null ? results[k]['Import of Records'].toString() : "",
                                "factura": results[k]['Número de factura'],
                                "fecha_factura": results[k]['Fecha de factura'],
                                "incoterm": results[k]['INCOTERM'],
                                "proyecto": results[k]['Proyecto'],
                                "conceptos":[{
                                    "cantidad": results[k]['Cantidad'],
                                    "unidad_medida": results[k]['Unidad de Medida'],
                                    "numero_parte": results[k]['Número de Parte'],
                                    "descripcion": results[k]['Descripción'],
                                    "fraccion": results[k]['Fracción Arancelaria'],
                                    "pais_origen": results[k]['País de Origen'],
                                    "precio_unitario": results[k]['Precio Unitario'],
                                    "total": results[k]['Total'],
                                }],                                
                                "observaciones": results[k]['Observaciones'],
                                "peso": results[k]['Peso'],
                                "bultos": results[k]['Número de Bultos'],
                                "dimensiones": results[k]['Dimensiones']!=null ? results[k]['Dimensiones'].toString() : "",
                            };
                        } else { //Sino solo se agregan conceptos
                            this.importData["conceptos"].push({
                                "cantidad": results[k]['Cantidad'],
                                "unidad_medida": results[k]['Unidad de Medida'],
                                "numero_parte": results[k]['Número de Parte'],
                                "descripcion": results[k]['Descripción'],
                                "fraccion": results[k]['Fracción Arancelaria'],
                                "pais_origen": results[k]['País de Origen'],
                                "precio_unitario": results[k]['Precio Unitario'],
                                "total": results[k]['Total'],
                            });
                        }                        
                    }

                    axios.post(this.$apiReportes + "reportes_ws/save_datos_factura_layout/", this.importData)
                    //axios.post("http://127.0.0.1:7000/reportes_ws/save_datos_factura_layout/", this.importData)
                        .then((res) => {
                            
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "La proforma se ha generado correctamente.",
                                footer: ""
                            });                           

                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar nuevamente.",
                                footer: ""
                            });                            
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();                                
                        });
                    
                }

            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        regenerarPdf: function(id_layout, key_pdf){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.post(this.$apiReportes + "reportes_ws/genera_proforma_layout/", {"rfc":this.$local_storage.get("rfc"),"id":id_layout})
            //axios.post("http://127.0.0.1:7000/reportes_ws/genera_proforma_layout/", {"rfc":this.$local_storage.get("rfc"),"id":id_layout})
                .then((res) => {                    
                    this.downloadReporte(key_pdf);
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al regenerar la Proforma. Favor de intentar nuevamente.",
                        footer: ""
                    });  
                    this.$root.$dialogLoader.hide();                         
                });
        },
        guardar_plantilla_s3: function(id_etiqueta){
            var self = this;
            var rfc = this.$local_storage.get("rfc"); 
            var keyFile = rfc + "/plantillas_activo_fijo/"+ id_etiqueta.toString() + "_"+ self.file_adjunto.name;
                    
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: self.file_adjunto.type
            }
            axios.post(self.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, self.file_adjunto, {headers:{'Content-Type': self.file_adjunto.type}})
                        .then((res) => { 
                            console.log("Archivo cargado correctamente a S3");
                        })                            
                        .catch((error)=>{                                                        
                            console.log("Error al cargar a S3: ", error);
                        });
                        
                    } else {
                        console.log("Undefined url de carga S3: ", res.data);
                    }
                })
                .catch((error) => {
                    console.log("Error al obtener url de carga S3: ", error);
            });
        },
        cargar: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc')                
            };
            axios.post(this.$apiReportes + "reportes_ws/consulta_factura_layout/", data)
            //axios.post("http://127.0.0.1:7000/reportes_ws/consulta_factura_layout/", data)
            .then(res => {
            if (typeof res.data !== "undefined") {
                this.datos = res.data;
                this.datos.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.created_at) - new Date(a.created_at) ;
                });
                for (var k in this.datos) {
                    this.datos[k].created_at = this.parseDate(this.datos[k].created_at);
                    this.datos[k].fecha_factura = this.parseDate(this.datos[k].fecha_factura);                    
                }
            }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        cargar_reportes: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc'),
                tipo: 'Proforma Layout PDF'
            };
            axios.post(this.URL + "get_reportes/", data)
            .then(res => {
            if (typeof res.data !== "undefined") {
                this.reportes = res.data;
                this.reportes.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                });
                for (var k in this.reportes) {
                    this.reportes[k].fecha_solicitud = this.parseDate(this.reportes[k].fecha_solicitud);
                    this.reportes[k].fecha_generacion = this.parseDate(this.reportes[k].fecha_generacion);
                    this.reportes[k].estatus = this.getEstatus(this.reportes[k].estatus);                    
                }
            }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        getEstatus: function(estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        
        eliminarLayout: function (id_layout) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el registro con No. Proceso: "+id_layout+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id: id_layout,
                }
                axios.post(this.$apiReportes + 'reportes_ws/delete_factura_layout/', datos)
                //axios.post('http://127.0.0.1:7000/reportes_ws/delete_factura_layout/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro. Intente nuevamente por favor.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();                        
                    });
              }
          });
        },
        generar_reporte_sqs() {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = this.model_busqueda;                               

                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        //url: "http://127.0.0.1:7000/reportes_ws/reporte_factura_layout/",                        
                        data: data
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406){
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.cargar_reportes();
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar_reportes();
                    });
              }
          });
        },
        downloadReporte: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = '_blank';
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
            },
                        
            
        
    }, //methods

    created: function () {    
        this.URL = this.$hostname+"reportes/";  
        this.model_busqueda.rfc = this.$local_storage.get("rfc");
        this.model_busqueda.usuario = this.$local_storage.get("id_usuario");  
        this.cargarEmisores();   
        this.cargar();
        this.cargar_reportes();

    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

#html_codigo_qr {
  display: inline-block;
  height: auto;
}
#html_codigo_qr img {
  max-width: 100%;
}

</style>
